import React, { useEffect, useState } from "react";
import Subheader from "../todoList/subheader";
import moment from "moment";
import { getService } from "../../services/genericPostService";
import { Path } from "../../RoutesUtils";
import { useNavigate } from "react-router-dom";
import Header from "../header/header";
import AddPopup from "./addPopup";
import UpdatePopup from "./updatePopup";
import { resources_EN } from "../componentUtils";

export const Clock = () => {
  const [time, setTime] = useState(new Date());
  const [events, setEvents] = useState([]);
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [openUpdatePopUp, setOpenUpdatePopup] = useState(false);
  const [updateData, setUpdateData] = useState({
    taskTitle: "",
    startMinute: "",
    startHour: "",
    endHour: "",
    endMinute: "",
  });

  const openPopup = (type, event = null) => {
    setPopupType(type);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupType(null);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (token) {
      getSchedule();
    } else {
      navigate(Path.login);
    }
  }, []);

  const getSchedule = () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const data = {
      user_id: userId,
      time_zone: userTimezone,
    };
    const url = "/fmeApi/get_clock_task.php";
    getService(url, data, setData);
  };

  const generateColor = (index) => {
    const colors = ["#2BBAF0", "#F39C12", "#E74C3C", "#8E44AD", "#27AE60"];
    return colors[index % colors.length];
  };

  const setData = (response) => {
    let data = response.schedule.map((val, index) => {
      return {
        id: val.clock_task_id,
        text: val.clock_task_title,
        start: moment(val.clock_task_start_time, "HH:mm:ss.SSSSSS").format(
          "HH:mm:ss"
        ),
        end: moment(val.clock_task_end_time, "HH:mm:ss.SSSSSS").format(
          "HH:mm:ss"
        ),
        color: generateColor(index),
        is_task_evening: val.is_task_evening,
      };
    });
    setEvents(data);
  };
  const calculateRotation = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const angle = (totalMinutes / (12 * 60)) * 360;
    return angle - 90; // 12 o'clock should be at -90°
  };
  

  /* Open Update Popup */
  const updatePopUp = (data) => {
    console.log("Data", data);
    setPopupType(+data.is_task_evening === 0 ? "morning" : "evening");
    setOpenUpdatePopup(true);
    setUpdateData(data);
  };

  /* Close Update Popup */
  const closeUpdatePopup = () => {
    setOpenUpdatePopup(false);
    setUpdateData({
      taskTitle: "",
      startMinute: "",
      startHour: "",
      endHour: "",
      endMinute: "",
    });
  };

  return (
    <>
      <Header />
      <Subheader title="Ur" />
      <div className="grid md:grid-cols-2 grid-cols-1 center-border relative">
        <div className="xl:mt-12 mt-10 xl:w-[70%] mx-auto">
          <h2 className="text-xl font-bold mb-8 text-green text-center">
            Ochtendklok 00:00am - 12:00pm
          </h2>
          <div className="clock-container flex flex-col items-center gap-8 justify-center">
            <div className="clock relative">
              <svg
                className="absolute top-0 left-0 w-full h-full"
                viewBox="0 0 100 100"
              >
                {events.map((event, index) => {
                  const startAngle = calculateRotation(event.start);
                  const endAngle = calculateRotation(event.end);
                  console.log("Eventtt", event);
                  if (+event.is_task_evening === 0) {
                    return (
                      <path
                        key={index}
                        d={`M 50 50 L ${
                          50 + 40 * Math.cos((Math.PI * startAngle) / 180)
                        } ${
                          50 + 40 * Math.sin((Math.PI * startAngle) / 180)
                        } A 40 40 0 0 1 ${
                          50 + 40 * Math.cos((Math.PI * endAngle) / 180)
                        } ${50 + 40 * Math.sin((Math.PI * endAngle) / 180)} Z`}
                        fill={event.color}
                        onClick={() => updatePopUp(event)}
                        opacity="0.8"
                      />
                    );
                  }
                })}
              </svg>
              {/* <div className="hand hour" style={{ transform: `rotate(${(time.getHours() % 12) * 30}deg)` }}></div> */}
              {/* <div className="hand minute" style={{ transform: `rotate(${time.getMinutes() * 6}deg)` }}></div> */}
              {/* <div className="hand second" style={{ transform: `rotate(${time.getSeconds() * 6}deg)` }}></div> */}
              {[...Array(12)].map((_, i) => (
                <div key={i} className={`number add-color number${i + 1}`}>
                  {i + 1}
                </div>
              ))}
            </div>
            <button
              type="button"
              onClick={() => openPopup("morning")}
              className="py-2.5 px-10 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
            >
              {resources_EN.addMorningTask}
            </button>
          </div>
          <div className="container mx-auto lg:px-8 px-4 lg:mt-16 mt-10 lg:mb-16 mb-10">
            <h2 className="text-lg font-semibold lg:mb-8 mb-5 text-green">
              Verdeling van ochtendtaak volgens kleuren
            </h2>
            <div className="lg:space-y-4 space-y-3">
              {events.length > 0 ? (
                events.map((val) => {
                  if (+val.is_task_evening === 0) {
                    return (
                      <div key={val.id} className="flex items-center gap-3">
                        <div
                          className="w-8 h-8 flex-shrink-0"
                          style={{ backgroundColor: val.color }}
                        ></div>
                        <p className="text-sm text-black">
                          {val.text} |
                          <span className="font-semibold">
                            {" "}
                            {val.start} - {val.end}
                          </span>
                        </p>
                      </div>
                    );
                  }
                })
              ) : (
                <p>{resources_EN.noTaskSchedule}</p>
              )}
            </div>
          </div>
        </div>
        <div className="xl:mt-12 mt-10 xl:w-[70%] mx-auto">
          <h2 className="text-xl font-bold mb-8 text-green text-center">
            Avondklok 12:00pm - 12:00am
          </h2>
          <div className="clock-container flex flex-col items-center gap-8 justify-center">
            <div className="clock relative">
              <svg
                className="absolute top-0 left-0 w-full h-full"
                viewBox="0 0 100 100"
              >
                {events.map((event, index) => {
                  const startAngle = calculateRotation(event.start);
                  const endAngle = calculateRotation(event.end);
                  if (+event.is_task_evening === 1) {
                    return (
                      <path
                        key={index}
                        style={{ cursor: "pointer" }}
                        d={`M 50 50 L ${
                          50 + 40 * Math.cos((Math.PI * startAngle) / 180)
                        } ${
                          50 + 40 * Math.sin((Math.PI * startAngle) / 180)
                        } A 40 40 0 0 1 ${
                          50 + 40 * Math.cos((Math.PI * endAngle) / 180)
                        } ${50 + 40 * Math.sin((Math.PI * endAngle) / 180)} Z`}
                        fill={event.color}
                        onClick={() => updatePopUp(event)}
                        opacity="0.5"
                      />
                    );
                  }
                })}
              </svg>
              {/* <div className="hand hour" style={{ transform: `rotate(${(time.getHours() % 12) * 30}deg)` }}></div> */}
              {/* <div className="hand minute" style={{ transform: `rotate(${time.getMinutes() * 6}deg)` }}></div> */}
              {/* <div className="hand second" style={{ transform: `rotate(${time.getSeconds() * 6}deg)` }}></div> */}
              {[...Array(12)].map((_, i) => (
                <div key={i} className={`number add-color number${i + 1}`}>
                  {i + 1}
                </div>
              ))}
            </div>
            <button
              type="button"
              onClick={() => openPopup("evening")}
              className="py-2.5 px-10 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
            >
              {resources_EN.addEveningTask}
            </button>
          </div>
          <div className="container mx-auto lg:px-8 px-4 lg:mt-16 mt-10 lg:mb-16 mb-10">
            <h2 className="text-lg font-semibold lg:mb-8 mb-5 text-green">
              Verdeling van avondtaak volgens kleuren
            </h2>
            <div className="lg:space-y-4 space-y-3">
              {events.length > 0 ? (
                events.map((val) => {
                  if (+val.is_task_evening === 1) {
                    return (
                      <div key={val.id} className="flex items-center gap-3">
                        <div
                          className="w-8 h-8 flex-shrink-0"
                          style={{ backgroundColor: val.color }}
                        ></div>
                        <p className="text-sm text-black">
                          {val.text} |
                          <span className="font-semibold">
                            {" "}
                            {val.start} - {val.end}
                          </span>
                        </p>
                      </div>
                    );
                  }
                })
              ) : (
                <p>{resources_EN.noTaskSchedule}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <AddPopup
        isOpen={isPopupOpen}
        onClose={closePopup}
        heading={
          popupType === "morning"
            ? resources_EN.addMorningTask
            : resources_EN.addEveningTask
        }
        buttonText={
          popupType === "morning"
            ? resources_EN.addMorningTask
            : resources_EN.addEveningTask
        }
        flag={popupType === "morning" ? 0 : 1}
        getSchedule={getSchedule}
      />
      <UpdatePopup
        isOpen={openUpdatePopUp}
        onClose={closeUpdatePopup}
        heading={
          popupType === "morning"
            ? resources_EN.updateMorningTask
            : resources_EN.updateEveningTask
        }
        buttonText={
          popupType === "morning"
            ? resources_EN.updateMorningTask
            : resources_EN.updateEveningTask
        }
        flag={popupType === "morning" ? 0 : 1}
        data={updateData}
        getSchedule={getSchedule}
      />
    </>
  );
};
